<template>
    <div>
        <p class="d-flex justify-center responsive-auth-font mb-1" style="color: darkgrey">{{ tb('Visite-nos nas nossas redes sociais:') }}</p>

        <div class="d-flex justify-center">
            <social-media :social-media="socialMedia.value" :includePropec="false" iconClass="mx-1 darker-gray-color"></social-media>
        </div>
    </div>
</template>

<script>
import useSocialMedia from '@/Composables/SocialMedia';

const { socialMedia, getSocialMedia } = useSocialMedia();

export default {
    data: () => ({
        socialMedia,
    }),

    created() {
        getSocialMedia();
    },
};
</script>
